export const MIN_GRID = 5;
export const MAX_GRID = 20;

export const gridSizeForLevel = (level: number): number => {
  const s = MIN_GRID + Math.floor((level - 1) / 3);
  return Math.min(MAX_GRID, Math.max(MIN_GRID, s));
};

/**
 * Match original cblix exactly:
 *   levels 1–100: ceil(minSteps + minSteps * 0.25 * (1 - (level-1)/99))
 *   levels 101+ : minSteps (no slack)
 */
export const moveBudgetForLevel = (level: number, minSteps: number): number => {
  if (level >= 101) return Math.max(1, minSteps);
  const slack = 1 - (level - 1) / 99;
  return Math.max(1, Math.ceil(minSteps + minSteps * 0.25 * slack));
};

/**
 * Special-tile spawn schedule MATCHING THE ORIGINAL CBLIX exactly.
 * (See cblix/plugins/{locked,penalty,rotation*,mirror*,flipping,inversion,chaos}.js.)
 *
 *   locked   level >= 2  density min(0.08, (level-1)*0.012)
 *   flipping level >= 4  density min(0.15, 0.05 + (level-5)*0.01)
 *   rotation level >= 6  density 0.15
 *   mirror   level >= 8  density 0.10
 *   penalty  level >= 8  density 0.05
 *   inversion level >= 10  1 cell, level >= 14  2 cells
 *   chaos    level >= 14  1 cell, level >= 20  2 cells
 */

export const lockedDensityForLevel = (level: number): number => {
  if (level < 2) return 0;
  return Math.min(0.08, (level - 1) * 0.012);
};

export const flippingDensityForLevel = (level: number): number => {
  if (level < 4) return 0;
  return Math.min(0.15, 0.05 + (level - 5) * 0.01);
};

export const rotationDensityForLevel = (level: number): number => {
  if (level < 6) return 0;
  return 0.15;
};

export const mirrorDensityForLevel = (level: number): number => {
  if (level < 8) return 0;
  return 0.1;
};

export const penaltyDensityForLevel = (level: number): number => {
  if (level < 8) return 0;
  return 0.05;
};

export const inversionCountForLevel = (level: number): number => {
  if (level < 10) return 0;
  if (level < 14) return 1;
  return 2;
};

export const chaosCountForLevel = (level: number): number => {
  if (level < 14) return 0;
  if (level < 20) return 1;
  return 2;
};
